import { formatRelativeDate } from "../hooks/useGalleryData";
import "./GallerySharingMetadata.css";

interface GallerySharingMetadataProps {
  lastModifiedAt?: string;
  sharedWithPeople?: boolean;
  sharedWithAi?: boolean;
}

export default function GallerySharingMetadata({
  lastModifiedAt,
  sharedWithPeople,
  sharedWithAi,
}: GallerySharingMetadataProps) {
  return (
    <div className="gallery-sharing-metadata">
      <div className="gallery-sharing-metadata-row">
        <time
          dateTime={lastModifiedAt}
          title={lastModifiedAt ? new Date(lastModifiedAt).toLocaleString() : undefined}
        >
          {lastModifiedAt ? formatRelativeDate(lastModifiedAt) : ""}
        </time>
        <span className="gallery-sharing-badges">
          {sharedWithPeople && (
            <span
              className="gallery-sharing-badge gallery-sharing-people"
              role="img"
              title="Shared with people"
              aria-label="Shared with people"
            >
              <svg
                width="13"
                height="13"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.8"
                aria-hidden="true"
              >
                <circle cx="9" cy="7" r="3" />
                <path d="M3 21v-3a6 6 0 0 1 12 0v3M16 4a3 3 0 0 1 0 6m2 4a5 5 0 0 1 3 5v2" />
              </svg>
              <span className="gallery-sharing-badge-label">People</span>
            </span>
          )}
          {sharedWithAi && (
            <span
              className="gallery-sharing-badge gallery-sharing-ai"
              role="img"
              title="Shared with your AI"
              aria-label="Shared with your AI"
            >
              <svg
                width="13"
                height="13"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.8"
                aria-hidden="true"
              >
                <rect x="4" y="7" width="16" height="13" rx="4" />
                <path d="M12 3v4M8 12v3m8-3v3M1 12v4m22-4v4" />
              </svg>
              <span className="gallery-sharing-badge-label">AI</span>
            </span>
          )}
          {(sharedWithPeople === undefined || sharedWithAi === undefined) && (
            <span
              role="img"
              title="Sharing status not confirmed"
              aria-label="Sharing status not confirmed"
            >
              <svg
                width="13"
                height="13"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.8"
                aria-hidden="true"
              >
                <circle cx="12" cy="12" r="9" />
                <path d="M10 8a2 2 0 1 1 3 2c-1 1-1 1-1 3m0 3v1" />
              </svg>
            </span>
          )}
        </span>
      </div>
    </div>
  );
}
